import IssueCategorisation from "./components/IssueCategorisation";

export default IssueCategorisation;